export const isNumericValue = (value: any) => !Number.isNaN(Number(value));

export const applyShippingFeeRowChanges = (selectedRow: any, updatedRow: any) => {
    const selectedRowCopy = { ...selectedRow };
    let isChange = false;

    if (
        updatedRow.shoppingAmount &&
        updatedRow.shoppingAmount != '' &&
        Number(updatedRow.shoppingAmount) != selectedRow.shoppingAmount
    ) {
        isChange = true;
        selectedRowCopy.shoppingAmount = updatedRow.shoppingAmount?.toString();
    }
    if (
        updatedRow.shipmentFee &&
        updatedRow.shipmentFee != '' &&
        Number(updatedRow.shipmentFee) != selectedRow.shipmentFee
    ) {
        isChange = true;
        selectedRowCopy.shipmentFee = updatedRow.shipmentFee?.toString();
    }
    if ((updatedRow.condition && updatedRow.condition === '<') || updatedRow.condition === '>=') {
        isChange = true;
        selectedRowCopy.condition = updatedRow.condition;
    }

    return { selectedRowCopy, isChange };
};

export const buildShippingFeeUpdatePayload = (selectedRowCopy: any, regionId: number) => {
    const updateData: any = {
        id: selectedRowCopy.id,
        regionId,
        tenant: 9,
        action: selectedRowCopy.shipmentFee?.toString(),
        ruleKey: 'ShippingFeeManagement',
        ruleTemplateId: selectedRowCopy.ruleTemplateId,
        criteria: [
            {
                key: 'shoppingAmount',
                operator: selectedRowCopy.condition?.includes('=') ? 1 : 2,
                value:
                    selectedRowCopy.condition === '<'
                        ? '0#' + selectedRowCopy.shoppingAmount?.toString()
                        : selectedRowCopy.shoppingAmount?.toString() + '#',
            },
            {
                key: 'DeliveryType',
                operator: 0,
                value: selectedRowCopy.deliveryType.toString(),
            },
            {
                key: 'ShippingCompanyId',
                operator: 0,
                value: selectedRowCopy.cargoCompany.toString(),
            },
            {
                key: 'region',
                operator: 0,
                value: selectedRowCopy.region?.toString(),
            },
        ],
    };

    return { rules: [updateData] };
};

export const buildCargoShipmentFilterData = (filterInput: any) => {
    const filterData: any = {
        ruleKey: 'ShippingFeeManagement',
        tenant: 9,
        skip: 0,
        take: 3000,
        status: 1,
    };
    const criterias: any = {};

    const isCargoCompanySelected =
        filterInput.cargoCompany && filterInput.cargoCompany !== 0 && filterInput.cargoCompany !== -100;
    const isDeliveryTypeSelected =
        filterInput.deliveryType && filterInput.deliveryType !== 0 && filterInput.deliveryType !== -100;
    const isActiveSelected =
        filterInput.status !== null &&
        (filterInput.status === 0 || filterInput.status === 1 || filterInput.status === 2);

    if (filterInput.region != null && filterInput.region !== -100) {
        criterias.region = filterInput.region.toString();
    }
    if (isCargoCompanySelected && filterInput.cargoCompany !== -100) {
        criterias.shippingCompanyId = filterInput.cargoCompany.toString();
    }
    if (isDeliveryTypeSelected && filterInput.deliveryType !== -100) {
        criterias.deliveryType = filterInput.deliveryType.toString();
    }
    if (isActiveSelected) {
        filterData.status = filterInput.status;
    }

    return { filterData, criterias, isNumericShoppingAmount: filterInput.shoppingAmount };
};
